import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { intakeNormalize } from "@/lib/intakeNormalize";
import { CompanyIntake, HttpResponse } from "@/types";

export function useGetCompanyIntake() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["company-intake", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/company-intake`;
      const res = await guacHttpClient.get<
        CompanyIntake | null,
        HttpResponse<CompanyIntake | null>
      >(path);
      // For some reason, backend is returning "" when empty causing errors.
      // Normalize so nested sub-objects are never null for consumers.
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      return intakeNormalize.company(res.data || null);
    },
  });
}
